import { envConfig } from '@/config/env';
import {
  getRemoteConfig,
  fetchAndActivate,
  getBoolean,
  type RemoteConfig,
} from 'firebase/remote-config';
import {
  initializeApp,
  type FirebaseApp,
  type FirebaseOptions,
} from 'firebase/app';

export const firebaseConfig: FirebaseOptions = {
  apiKey: envConfig.firebase.apiKey,
  authDomain: envConfig.firebase.authDomain,
  projectId: envConfig.firebase.projectId,
  appId: envConfig.firebase.appId,
};

export const firebase: FirebaseApp = initializeApp(firebaseConfig);

const remoteConfig: RemoteConfig = getRemoteConfig(firebase);
remoteConfig.settings.minimumFetchIntervalMillis = 30000;

export async function activateRemoteConfig(): Promise<boolean> {
  try {
    await fetchAndActivate(remoteConfig);

    return true;
  } catch {
    return false;
  }
}

export async function getFeatureFlag(flag: string): Promise<boolean> {
  await fetchAndActivate(remoteConfig);

  return getBoolean(remoteConfig, flag);
}
